

const categories = [
  { id: 1, name: 'All Catagories', description: 'Discuss the latest in tech', postCount: 556, color: '#66ff00ff' },
  { id: 2, name: 'Maize', description: 'Gaming discussions and reviews', postCount: 89, color: '#ff9800' }, // updated
  { id: 3, name: 'Rice', description: 'Sports news and discussions', postCount: 234, color: '#f57c00' },
  { id: 4, name: 'Cotton', description: 'Entertainment discussions', postCount: 78, color: '#9c27b0' }, // updated
  { id: 5, name: 'Sugarcane', description: 'Scientific discussions and news', postCount: 145, color: '#d32f2f' },
  { id: 6, name: 'Fodder', description: 'Share your travel experiences', postCount: 67, color: '#0288d1' },
  { id: 7, name: 'Other', description: 'Recipes and cooking tips', postCount: 198, color: '#689f38' },
  { id: 8, name: 'Fruits & Vegetables', description: 'Topic related to Fruits & Vegetables', postCount: 120, color: '#fbc02d' },
  { id: 9, name: 'Pulses', description: 'Topic related to Pulses', postCount: 95, color: '#e64a19' }, // updated
  { id: 10, name: 'Genral', description: 'General topics and discussions', postCount: 300, color: '#009688' }, // updated
  { id: 11, name: 'Marketing', description: 'Marketing strategies and tips', postCount: 80, color: '#c2185b' },
  { id: 12, name: 'Wheat', description: 'Discuss the latest in tech', postCount: 156, color: '#1976d2' },
];

// Helper to map category IDs to colors for efficient lookup
const categoryColorMap = categories.reduce((acc, category) => {
  acc[category.id] = category.color;
  return acc;
}, {});

const posts = [
  {
    id: 1,
    categoryId: 1,
    categoryName: 'Wheat',
    categoryColor: categoryColorMap[1],
    title: 'The Future of Artificial Intelligence',
    author: 'TechGuru2023',
    authorAvatar: 'https://i.pravatar.cc/150?img=1',
    createdAt: '2024-01-15T10:30:00Z',
    body: '<h2>Introduction</h2><p>Artificial Intelligence is rapidly evolving and transforming our world. In this post, I want to discuss the potential future developments in AI and their implications for society.</p>',
    likes: 45,
    commentCount: 12
  },
  {
    id: 2,
    categoryId: 1,
    categoryName: 'Wheat',
    categoryColor: categoryColorMap[1],
    title: 'Best Programming Languages to Learn in 2024',
    author: 'CodeMaster',
    authorAvatar: 'https://i.pravatar.cc/150?img=2',
    createdAt: '2024-01-14T15:20:00Z',
    body: '<p>As we move into 2024, the programming landscape continues to evolve...</p>',
    likes: 67,
    commentCount: 23
  },
  {
    id: 3,
    categoryId: 2,
    categoryName: 'Maize',
    categoryColor: categoryColorMap[2],
    title: 'Review: The Latest Gaming Graphics Cards',
    author: 'GameReviewer',
    authorAvatar: 'https://i.pravatar.cc/150?img=3',
    createdAt: '2024-01-13T09:45:00Z',
    body: '<h3>RTX 4090 vs RTX 4080</h3><p>I\'ve been testing both cards...</p>',
    likes: 89,
    commentCount: 34
  },
  {
    id: 4,
    categoryId: 3,
    categoryName: 'Rice',
    categoryColor: categoryColorMap[3],
    title: 'World Cup 2024 Predictions',
    author: 'SportsAnalyst',
    authorAvatar: 'https://i.pravatar.cc/150?img=4',
    createdAt: '2024-01-12T18:30:00Z',
    body: '<p>With the World Cup approaching, let\'s discuss the potential winners...</p>',
    likes: 123,
    commentCount: 56
  },
  {
    id: 5,
    categoryId: 1,
    categoryName: 'Wheat',
    categoryColor: categoryColorMap[1],
    title: 'Cloud Computing Trends in 2024',
    author: 'CloudExpert',
    authorAvatar: 'https://i.pravatar.cc/150?img=5',
    createdAt: '2024-01-11T14:15:00Z',
    body: '<p>The cloud computing landscape is evolving rapidly. Here are the key trends to watch...</p>',
    likes: 78,
    commentCount: 19
  },

  // ---------------- 20 NEW POSTS ----------------
  {
    id: 6,
    categoryId: 1,
    categoryName: 'Wheat',
    categoryColor: categoryColorMap[1],
    title: 'Advancements in Machine Learning',
    author: 'DataWizard',
    authorAvatar: 'https://i.pravatar.cc/150?img=6',
    createdAt: '2024-01-10T10:00:00Z',
    body: '<p>Machine learning models are getting more powerful and efficient...</p>',
    likes: 54,
    commentCount: 14
  },
  {
    id: 7,
    categoryId: 2,
    categoryName: 'Maize',
    categoryColor: categoryColorMap[2],
    title: 'Esports Growth in 2024',
    author: 'ProGamer',
    authorAvatar: 'https://i.pravatar.cc/150?img=7',
    createdAt: '2024-01-09T17:30:00Z',
    body: '<p>Esports is now a billion-dollar industry...</p>',
    likes: 102,
    commentCount: 41
  },
  {
    id: 8,
    categoryId: 3,
    categoryName: 'Rice',
    categoryColor: categoryColorMap[3],
    title: 'Nutrition Benefits of Rice',
    author: 'HealthGuru',
    authorAvatar: 'https://i.pravatar.cc/150?img=8',
    createdAt: '2024-01-08T13:20:00Z',
    body: '<p>Rice provides essential carbohydrates and energy...</p>',
    likes: 34,
    commentCount: 7
  },
  {
    id: 9,
    categoryId: 4,
    categoryName: 'Barley',
    categoryColor: categoryColorMap[4],
    title: 'Blockchain Beyond Cryptocurrency',
    author: 'CryptoThinker',
    authorAvatar: 'https://i.pravatar.cc/150?img=9',
    createdAt: '2024-01-07T11:45:00Z',
    body: '<p>Blockchain technology has potential applications in supply chain...</p>',
    likes: 63,
    commentCount: 18
  },
  {
    id: 10,
    categoryId: 5,
    categoryName: 'Soybean',
    categoryColor: categoryColorMap[5],
    title: 'Top 10 Mobile Apps of 2024',
    author: 'AppReviewer',
    authorAvatar: 'https://i.pravatar.cc/150?img=10',
    createdAt: '2024-01-06T09:15:00Z',
    body: '<p>Here are the mobile apps making waves in 2024...</p>',
    likes: 90,
    commentCount: 25
  },
  {
    id: 11,
    categoryId: 6,
    categoryName: 'Sugarcane',
    categoryColor: categoryColorMap[6],
    title: 'How Renewable Energy is Changing the World',
    author: 'EcoWarrior',
    authorAvatar: 'https://i.pravatar.cc/150?img=11',
    createdAt: '2024-01-05T14:10:00Z',
    body: '<p>Solar and wind energy are reshaping how we power our homes...</p>',
    likes: 112,
    commentCount: 36
  },
  {
    id: 12,
    categoryId: 7,
    categoryName: 'Cotton',
    categoryColor: categoryColorMap[7],
    title: 'The Psychology of Social Media',
    author: 'MindExplorer',
    authorAvatar: 'https://i.pravatar.cc/150?img=12',
    createdAt: '2024-01-04T16:00:00Z',
    body: '<p>Social media has profound effects on our mental health...</p>',
    likes: 77,
    commentCount: 22
  },
  {
    id: 13,
    categoryId: 8,
    categoryName: 'Oats',
    categoryColor: categoryColorMap[8],
    title: 'Latest Trends in E-commerce',
    author: 'ShopSmart',
    authorAvatar: 'https://i.pravatar.cc/150?img=13',
    createdAt: '2024-01-03T12:50:00Z',
    body: '<p>Online shopping continues to grow rapidly in 2024...</p>',
    likes: 88,
    commentCount: 29
  },
  {
    id: 14,
    categoryId: 9,
    categoryName: 'Millet',
    categoryColor: categoryColorMap[9],
    title: 'Exploring Space in 2024',
    author: 'AstroGeek',
    authorAvatar: 'https://i.pravatar.cc/150?img=14',
    createdAt: '2024-01-02T18:25:00Z',
    body: '<p>New missions are planned to Mars and beyond...</p>',
    likes: 134,
    commentCount: 48
  },
  {
    id: 15,
    categoryId: 10,
    categoryName: 'Sorghum',
    categoryColor: categoryColorMap[10],
    title: 'How 5G is Transforming Technology',
    author: 'TechInsider',
    authorAvatar: 'https://i.pravatar.cc/150?img=15',
    createdAt: '2024-01-01T08:40:00Z',
    body: '<p>5G is enabling new possibilities for connectivity...</p>',
    likes: 99,
    commentCount: 30
  },
  {
    id: 16,
    categoryId: 11,
    categoryName: 'Lentils',
    categoryColor: categoryColorMap[11],
    title: 'Rise of Electric Vehicles',
    author: 'AutoExpert',
    authorAvatar: 'https://i.pravatar.cc/150?img=16',
    createdAt: '2023-12-31T11:10:00Z',
    body: '<p>Electric vehicles are becoming mainstream...</p>',
    likes: 143,
    commentCount: 52
  },
  {
    id: 17,
    categoryId: 1,
    categoryName: 'Wheat',
    categoryColor: categoryColorMap[1],
    title: 'AI in Agriculture',
    author: 'AgriTechie',
    authorAvatar: 'https://i.pravatar.cc/150?img=17',
    createdAt: '2023-12-30T15:45:00Z',
    body: '<p>AI is now helping farmers with crop prediction...</p>',
    likes: 60,
    commentCount: 20
  },
  {
    id: 18,
    categoryId: 2,
    categoryName: 'Maize',
    categoryColor: categoryColorMap[2],
    title: 'Future of Virtual Reality',
    author: 'VRFanatic',
    authorAvatar: 'https://i.pravatar.cc/150?img=18',
    createdAt: '2023-12-29T09:30:00Z',
    body: '<p>VR is evolving into more immersive experiences...</p>',
    likes: 84,
    commentCount: 27
  },
  {
    id: 19,
    categoryId: 3,
    categoryName: 'Rice',
    categoryColor: categoryColorMap[3],
    title: 'Impact of Globalization on Food',
    author: 'Foodie',
    authorAvatar: 'https://i.pravatar.cc/150?img=19',
    createdAt: '2023-12-28T20:00:00Z',
    body: '<p>Globalization has made cuisines more accessible...</p>',
    likes: 71,
    commentCount: 18
  },
  {
    id: 20,
    categoryId: 4,
    categoryName: 'Barley',
    categoryColor: categoryColorMap[4],
    title: 'The Future of Cloud Gaming',
    author: 'CloudGamer',
    authorAvatar: 'https://i.pravatar.cc/150?img=20',
    createdAt: '2023-12-27T11:20:00Z',
    body: '<p>Streaming games is becoming the new norm...</p>',
    likes: 96,
    commentCount: 24
  },
  {
    id: 21,
    categoryId: 5,
    categoryName: 'Soybean',
    categoryColor: categoryColorMap[5],
    title: 'Health Benefits of Plant-Based Diets',
    author: 'Nutritionist101',
    authorAvatar: 'https://i.pravatar.cc/150?img=21',
    createdAt: '2023-12-26T13:15:00Z',
    body: '<p>Switching to plant-based diets has numerous benefits...</p>',
    likes: 58,
    commentCount: 15
  },
  {
    id: 22,
    categoryId: 6,
    categoryName: 'Sugarcane',
    categoryColor: categoryColorMap[6],
    title: 'AI in Healthcare',
    author: 'MediTech',
    authorAvatar: 'https://i.pravatar.cc/150?img=22',
    createdAt: '2023-12-25T10:45:00Z',
    body: '<p>Artificial intelligence is improving diagnostics...</p>',
    likes: 105,
    commentCount: 32
  },
  {
    id: 23,
    categoryId: 7,
    categoryName: 'Cotton',
    categoryColor: categoryColorMap[7],
    title: 'Top Fashion Trends in 2024',
    author: 'StyleGuru',
    authorAvatar: 'https://i.pravatar.cc/150?img=23',
    createdAt: '2023-12-24T17:00:00Z',
    body: '<p>The fashion industry is shifting towards sustainability...</p>',
    likes: 92,
    commentCount: 28
  },
  {
    id: 24,
    categoryId: 8,
    categoryName: 'Oats',
    categoryColor: categoryColorMap[8],
    title: 'Fitness Trends in 2024',
    author: 'FitLife',
    authorAvatar: 'https://i.pravatar.cc/150?img=24',
    createdAt: '2023-12-23T19:00:00Z',
    body: '<p>New fitness tech and routines are taking over gyms...</p>',
    likes: 87,
    commentCount: 21
  },
  {
    id: 25,
    categoryId: 9,
    categoryName: 'Millet',
    categoryColor: categoryColorMap[9],
    title: 'Space Tourism: Are We Ready?',
    author: 'SpaceDreamer',
    authorAvatar: 'https://i.pravatar.cc/150?img=25',
    createdAt: '2023-12-22T21:30:00Z',
    body: '<p>Commercial space flights are becoming a reality...</p>',
    likes: 115,
    commentCount: 37
  }
];

const comments = [
  {
    id: 1,
    postId: 1,
    author: 'AIEnthusiast',
    authorAvatar: 'https://i.pravatar.cc/150?img=6',
    content: 'Great post! I think AI will revolutionize healthcare in the next decade.',
    createdAt: '2024-01-15T11:00:00Z',
    likes: 12
  },
  {
    id: 2,
    postId: 1,
    author: 'SkepticalDev',
    authorAvatar: 'https://i.pravatar.cc/150?img=7',
    content: 'While AI is promising, we need to be careful about the ethical implications.',
    createdAt: '2024-01-15T11:30:00Z',
    likes: 8
  },
  {
    id: 3,
    postId: 1,
    author: 'FutureTech',
    authorAvatar: 'https://i.pravatar.cc/150?img=8',
    content: 'I agree with both perspectives. The key is responsible development.',
    createdAt: '2024-01-15T12:00:00Z',
    likes: 15
  },
  {
    id: 4,
    postId: 2,
    author: 'PythonLover',
    authorAvatar: 'https://i.pravatar.cc/150?img=9',
    content: 'Python is definitely my top choice! The ecosystem is incredible.',
    createdAt: '2024-01-14T16:00:00Z',
    likes: 23
  },
  {
    id: 5,
    postId: 2,
    author: 'RustFan',
    authorAvatar: 'https://i.pravatar.cc/150?img=10',
    content: 'Rust is gaining so much traction. Memory safety without garbage collection!',
    createdAt: '2024-01-14T16:30:00Z',
    likes: 18
  }
];

// Simulate network delay
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// API functions
export const fetchCategories = async (query = '') => {
  await delay(500);
  
  // Simulate occasional API failure
  // if (Math.random() < 0.1) {
  //   throw new Error('Failed to fetch categories');
  // }
  
  let filteredCategories = categories;
  if (query) {
    filteredCategories = categories.filter(category =>
      category.name.toLowerCase().includes(query.toLowerCase()) ||
      category.description.toLowerCase().includes(query.toLowerCase())
    );
  }
  
  return {
    success: true,
    data: filteredCategories
  };
};

export const fetchPosts = async (categoryId, page = 1, limit = 10) => {
  await delay(800);
  
  // Simulate occasional API failure
  if (Math.random() < 0.1) {
    throw new Error('Failed to fetch posts');
  }
  
  let filteredPosts = posts;
  if (categoryId) {
    filteredPosts = posts.filter(post => post.categoryId === parseInt(categoryId));
  }
  
  // Generate more posts for pagination simulation
  const totalPosts = filteredPosts.length * 3; // Simulate more posts
  const startIndex = (page - 1) * limit;
  const endIndex = startIndex + limit;
  
  // Create additional dummy posts if needed
  const additionalPosts = [];
  for (let i = filteredPosts.length; i < totalPosts; i++) {
    const basePost = filteredPosts[i % filteredPosts.length];
    additionalPosts.push({
      ...basePost,
      id: i + 100,
      title: `${basePost.title} - Part ${Math.floor(i / filteredPosts.length) + 1}`,
      createdAt: new Date(Date.now() - i * 3600000).toISOString()
    });
  }
  
  const allPosts = [...filteredPosts, ...additionalPosts];
  const paginatedPosts = allPosts.slice(startIndex, endIndex);
  
  return {
    success: true,
    data: paginatedPosts,
    pagination: {
      page,
      limit,
      total: totalPosts,
      hasMore: endIndex < totalPosts
    }
  };
};

export const fetchPostDetails = async (postId) => {
  await delay(600);
  
  // Simulate occasional API failure
  if (Math.random() < 0.1) {
    throw new Error('Failed to fetch post details');
  }
  
  const post = posts.find(p => p.id === parseInt(postId));
  if (!post) {
    throw new Error('Post not found');
  }
  
  return {
    success: true,
    data: post
  };
};

export const fetchComments = async (postId) => {
  await delay(400);
  
  const postComments = comments.filter(c => c.postId === parseInt(postId));
  
  return {
    success: true,
    data: postComments
  };
};

export const toggleLike = async (itemId, itemType) => {
  await delay(300);
  
  // Simulate like toggle
  return {
    success: true,
    data: {
      liked: Math.random() > 0.5,
      likeCount: Math.floor(Math.random() * 100)
    }
  };
};

export const createPost = async (postData) => {
  await delay(1000);
  
  // Simulate occasional API failure
  if (Math.random() < 0.1) {
    throw new Error('Failed to create post');
  }
  
  const newPost = {
    id: posts.length + 1,
    ...postData,
    author: 'CurrentUser',
    authorAvatar: 'https://i.pravatar.cc/150?img=1',
    createdAt: new Date().toISOString(),
    likes: 0,
    commentCount: 0
  };
  
  posts.push(newPost);
  
  return {
    success: true,
    data: newPost
  };
};

export const getCategoryById = (categoryId) => {
  return categories.find(c => c.id === parseInt(categoryId));
};
